// extracted by mini-css-extract-plugin
module.exports = {"date":"_7d3c597","section":"_eba5c7f","row":"_8d06aac","cell":"_0f9043d","label":"_3fabd82"};